import { TASK_STATUS } from '@/service/rewardService'
import { REWARD_TASK_ID } from '@/service/rewardTaskHandlers'

const FALLBACK_LOGIN_REWARD_AMOUNT = 40

export function claimableRewardAmountForTasks (tasks) {
  return (Array.isArray(tasks) ? tasks : []).reduce((sum, task) => {
    if (task?.status !== TASK_STATUS.CLAIMABLE) return sum
    return sum + Math.max(0, Number(task.amount) || 0)
  }, 0)
}

export function getLoginRewardBubbleState (tasks) {
  const loginTask = (Array.isArray(tasks) ? tasks : [])
    .find((item) => item?.task_id === REWARD_TASK_ID.LOGIN)
  const amount = Number(loginTask?.amount) || FALLBACK_LOGIN_REWARD_AMOUNT

  return {
    show: loginTask?.status === TASK_STATUS.UNFINISHED,
    amount
  }
}
